/**
 * Dia e hora civis de São Paulo nos campos nativos de data e hora.
 *
 * Vive fora da página porque a mesma conversão é usada pelo quadro de Tarefas e
 * pelo perfil do lead; duas cópias divergiriam justamente no caso difícil, o do
 * horário de verão (AGENTS §6, §7.6).
 */
export const TIME_ZONE = "America/Sao_Paulo";

/** Valor `YYYY-MM-DDTHH:mm` para os campos nativos de data e hora. */
export function localParts(instant: Date): { date: string; time: string } {
  const date = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(instant);
  const time = new Intl.DateTimeFormat("en-GB", {
    timeZone: TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
  }).format(instant);
  return { date, time };
}

/**
 * Monta o instante UTC a partir do dia e da hora civis de São Paulo.
 *
 * O deslocamento é medido no próprio dia escolhido, então o horário de verão —
 * se voltar — não desloca o prazo em uma hora (§7.6).
 */
export function toInstant(date: string, time: string): string | null {
  if (!date || !time) return null;
  const naive = Date.parse(`${date}T${time}:00Z`);
  if (Number.isNaN(naive)) return null;
  const guessed = new Date(naive);
  const shown = new Intl.DateTimeFormat("en-US", {
    timeZone: TIME_ZONE,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(guessed);
  const part = (type: string) => Number(shown.find((item) => item.type === type)?.value ?? "0");
  const asUtc = Date.UTC(
    part("year"),
    part("month") - 1,
    part("day"),
    part("hour") % 24,
    part("minute"),
    part("second"),
  );
  return new Date(naive + (naive - asUtc)).toISOString();
}
